// E_ -> is an identifier that this is an editor control type
export default {
  E_GRAPHQL_PAGINATION: "E_GRAPHQL_PAGINATION",
};
